import type { OverlayScreenProps } from 'open-modules/zdf/component/overlay';
import { OverlayScreen } from 'open-modules/zdf/component/overlay';

// This container handles that each voting window has its correct position and
// size
type VideoVotingOverlayProps = OverlayScreenProps;
export function VideoVotingOverlay({
    children,
    visible = true,
    showBackdrop = false,
    pointerEvents = true,
    style,
}: VideoVotingOverlayProps) {
    return (
        <OverlayScreen pointerEvents={pointerEvents} showBackdrop={showBackdrop} style={style} visible={visible}>
            {children}
        </OverlayScreen>
    );
}
